import React from "react";

const CircularProgress = ({className}) => <div className={`loader ${className}`}>
  <img src="/assets/images/Dash-Circle-Preloader.svg" alt="loader"/>
</div>;
export default CircularProgress;
